import {
    iconRequest,
    iconClient,
    iconCalculator,
    iconSearch,
    iconAffiliate,
    iconReports,
    iconReportsDefault,
    iconCertificate,
    iconNeighborhood,
    iconZonification,
    iconParameters,
    iconDocs,
    iconPerson,
    iconConsults
} from '../defaultValues';

const data = {
    role_24702d7c49234abdb6b9f1c903325b1d: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
         {
            id: 'buro',
            icon: iconConsults,
            label: 'Consultas Buró',
            to: '/app/BuroConsults',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'aliados',
                    icon: iconAffiliate,
                    label: 'Aliados',
                    to: '/app/aliados',
                },
                {
                    id: 'barrios',
                    icon: iconNeighborhood,
                    label: 'Barrios',
                    to: '/app/barrios',
                },
                {
                    id: 'personas',
                    icon: iconPerson,
                    label: 'Personas',
                    to: '/app/persons',
                },
            ],
        },

        {
            id: 'zonification',
            icon: iconZonification,
            label: 'Zonificación',
            to: '/app/zonification',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Desempeño Usuario',
                    to: '/app/reports/teamPerformance',
                },
            ],
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            to: '/app/calculator',
            subs: [
                {
                    id: 'certificados',
                    icon: iconCertificate,
                    label: 'Certificados',
                    to: '/app/reports/peaceAndSafe',
                    subs: [
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Registrar',
                            to: '/app/reports/peaceAndSafe',
                        },
                        {
                            id: 'fng-reports',
                            icon: iconCertificate,
                            label: 'Consultar',
                            to: '/app/reports/checkCertificates',
                        },
                    ],
                },
            ],
        },
    ],
};
export default data;
